import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { useAuthState, useSelectedUser } from 'features/auth/hooks/federatedAuthHooks';
import { LoginFederated } from './LoginFederated';
import { SwitchUserFederated } from './SwitchUserFederated';

export const AuthLoaderFederated = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuthState();
  const { selectedUserId } = useSelectedUser();

  if (isLoading) {
    return (
      <Center>
        <CircularProgress />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <LoginFederated />;
  }

  if (!selectedUserId) {
    return <SwitchUserFederated />;
  }

  return children;
};

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: ${p => p.theme.palette.bg.secondary};
`;
